import { curry } from 'lodash'
import { SelectOption } from 'scenes/Dashboard/components/Inputs/Select/Common/Select.model'
import { getOrganizationEventLabel } from 'scenes/Dashboard/data/organizationEvents/helpers'
import { OrganizationEvent, OrganizationEventType } from 'scenes/Dashboard/data/organizationEvents/types'

export type OrganizationEventFormValue = Omit<OrganizationEvent, 'type' | 'happenedOn'> & {
  type: SelectOption
  happenedOn: string
}

export const parseOrganizationEventToFormValue = (organizationEvent: OrganizationEvent): OrganizationEventFormValue => {
  const happenedOnUtc = new Date(organizationEvent.happenedOn)
  const happenedOnInCurrentTimezone = new Date(happenedOnUtc)
  happenedOnInCurrentTimezone.setMinutes(
    happenedOnInCurrentTimezone.getMinutes() - happenedOnInCurrentTimezone.getTimezoneOffset()
  )
  return {
    ...organizationEvent,
    happenedOn: happenedOnInCurrentTimezone.toISOString().slice(0, 16),
    type: getOptionFromOrganizationEventType(organizationEvent.type),
  }
}

export const getOptionFromOrganizationEventType = (type: string | OrganizationEventType): SelectOption => ({
  value: type,
  label: getOrganizationEventLabel(type),
})

export const parseFormValueToOrganizationEvent = curry(
  (
    organizationId: OrganizationEvent['organizationId'],
    organizationEventFormValue: OrganizationEventFormValue
  ): OrganizationEvent => {
    return {
      ...organizationEventFormValue,
      organizationId,
      happenedOn: new Date(organizationEventFormValue.happenedOn).toISOString(),
      type: getOrganizationEventTypeFromOption(organizationEventFormValue.type),
    }
  }
)

export const getOrganizationEventTypeFromOption = (option: SelectOption): OrganizationEventType =>
  option && (option.value as OrganizationEventType)
